export default __webpack_public_path__ + "static/media/ed2mit2020practice02-virtualbox-cloudera-quickstart-v02.ef23f8d5.pdf";